export default __webpack_public_path__ + "static/media/baseline-settings-20px.945c5c5f.svg";